import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { ErrorMessage, Package, PackageUpdateSalesPortalOptions } from 'types';
import { client } from 'utils/api-client';

export default function useUpdateSalesPortalOptions(): UseMutationResult<
  AxiosResponse<Package>,
  AxiosError<ErrorMessage>,
  PackageUpdateSalesPortalOptions
> {
  const queryClient = useQueryClient();

  const updateSalesPortalOptions = (p: PackageUpdateSalesPortalOptions): Promise<AxiosResponse<Package>> => {
    return client.put(`packages/${p.packageId}/update-sales-portal-options/`, p);
  };

  return useMutation(updateSalesPortalOptions, {
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['packages'],
      });
      queryClient.invalidateQueries({
        queryKey: ['billingPlans'],
      });
    },
  });
}
